export const privacyContent = (
  <>
    <h2>Information We Collect</h2>
    <p>
      We collect only the minimum information required to provide collaborative
      document editing and authentication services, such as account credentials
      and document data created by users.
    </p>

    <h2>How We Use Data</h2>
    <ul>
      <li>Account authentication and access control</li>
      <li>Real-time collaboration and document synchronization</li>
      <li>Security, abuse prevention, and system integrity</li>
    </ul>

    <h2>User Content Ownership</h2>
    <p>
      You retain full ownership of the content you create. SyncDraft does not
      claim ownership over any user-generated documents or data.
    </p>

    <h2>Third-Party Services</h2>
    <p>
      SyncDraft relies on third-party infrastructure providers for hosting,
      storage, and networking. These providers process data only as necessary
      to deliver the service.
    </p>

    <h2>Data Security</h2>
    <p>
      All data is encrypted in transit and protected using industry-standard
      security practices. However, no system can be guaranteed to be completely
      secure.
    </p>
  </>
)

export const termsContent = (
  <>
    <h2>Acceptance of Terms</h2>
    <p>
      By accessing or using SyncDraft, you agree to be bound by these Terms of
      Service.
    </p>

    <h2>Acceptable Use</h2>
    <ul>
      <li>No illegal, harmful, or abusive content</li>
      <li>No attempts to disrupt or compromise the service</li>
      <li>No misuse of the platform that harms other users</li>
    </ul>

    <h2>Open Source Notice</h2>
    <p>
      SyncDraft is an open-source project. The source code is publicly available,
      and the software is provided for transparency and community collaboration.
    </p>

    <h2>No Warranty</h2>
    <p>
      The service is provided &quot;as is&quot; without warranties of any kind.
      We do not guarantee uninterrupted availability, data integrity, or error-
      free operation.
    </p>

    <h2>Limitation of Liability</h2>
    <p>
      SyncDraft and its contributors shall not be liable for any damages arising
      from the use or inability to use the service.
    </p>

    <h2>Termination</h2>
    <p>
      Access to the service may be suspended or terminated in cases of abuse,
      security risk, or violation of these terms.
    </p>
  </>
)

export const cookieContent = (
  <>
    <h2>What Are Cookies</h2>
    <p>
      Cookies are small files stored on your device to support secure sessions
      and essential application functionality.
    </p>

    <h2>Cookies We Use</h2>
    <ul>
      <li>Authentication and session cookies</li>
      <li>Security-related cookies</li>
    </ul>

    <h2>What We Do Not Use</h2>
    <p>
      SyncDraft does not use cookies for advertising, tracking, or behavioral
      analytics.
    </p>

    <h2>Managing Cookies</h2>
    <p>
      You may disable cookies in your browser settings, but some features of the
      service may not function correctly as a result.
    </p>
  </>
)
